import * as _ from 'lodash';
import { ActionType } from './actions';
import { Production } from '../../classes/production';
import { Series } from '../../classes/series';
import axios, { AxiosRequestConfig } from "axios";
import { Dispatch } from 'redux';
import { FestivalOverviewAppState } from '../../classes/redux-states';
import { FestivalOverviewSettings } from '../../classes/settings';

export function requestFestivalSeries() {
    return {
        type: ActionType.REQUEST_NEXT_BATCH
    }
}

export function updatePageId(pageId: string) {
    return {
        type: ActionType.SET_PAGE_ID,
        value: pageId
    }
}

export function requestSettings() {
    return {
        type: ActionType.REQUEST_SETTINGS
    }
}

function settingsResponse(response: FestivalOverviewSettings) {
    return {
        type: ActionType.RECEIVE_SETTINGS,
        value: {
            festivalOverviewSetting: response
        }
    }
}

interface FestivalSeriesResponse {
    currentDay: string;
    series: Series[];
    dayLabel: string;
}
export function festivalSeriesResponse(response: FestivalSeriesResponse) {
    return {
        type: ActionType.RECEIVE_NEXT_BATCH,
        value: {
            seriesList: response.series,
            currentDay: response.currentDay,
            dayLabel: response.dayLabel
        }
    }
}

export function getSettings(id: string) {
    return (dispatch: Dispatch<FestivalOverviewAppState>, getState: () => FestivalOverviewAppState) => {
        let state = getState();
        dispatch(requestSettings());
        axios.post<FestivalOverviewSettings>('/api/FestivalOverview/getSettings',
            {
                PageId: id
            })
            .then(response => {
                const settings = response.data;
                state = getState();
                getFestivalSeries(settings.currentDay);
                dispatch(settingsResponse(settings));
            })
    }
}

export function getFestivalSeries(day: string) {

    return (dispatch: Dispatch<FestivalOverviewAppState>, getState: () => FestivalOverviewAppState) => {
        let state = getState();
        let id = state.festivalOverviewSettingsModel.pageId;
        let currentDay = day == '' ? state.festivalOverviewApiModel.currentDay : day;
        dispatch(requestFestivalSeries());
        axios.post<FestivalSeriesResponse>('/api/FestivalOverview/getSeries',
            {
                Day: currentDay,
                PageId: id

            }).then(response => {
                const seriesData = response.data;
                state = getState();
                dispatch(festivalSeriesResponse(seriesData));
            });
    }
}

